import React from 'react'

import AnnouncementBody from './AnnouncementBody'
import AnnouncementDetailHeader from './AnnouncementDetailHeader'
import { AnnouncementDetailSection } from './styles'

const AnnouncementDetail = ({ show, setShow, searchshow }) => {
	const handleBack = () => {
		// show 객체의 기존 데이터는 유지하면서 show 속성만 false로 변경
		setShow(prev => ({
			...prev,
			show: false
		}))
	}

	return (
		<AnnouncementDetailSection>
			<AnnouncementDetailHeader 
				show={show} 
				setShow={handleBack} 
				searchshow={searchshow}
			/>
			<AnnouncementBody show={show} searchshow={searchshow}/>
		</AnnouncementDetailSection>
	)
}

export default AnnouncementDetail
